/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  closeBtn: {
    type: [Boolean, Function],
    "default": true
  },
  closeOnOverlay: Boolean,
  draggable: {
    type: Boolean,
    "default": void 0
  },
  imageScale: {
    type: Object
  },
  images: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  index: {
    type: Number,
    "default": void 0
  },
  defaultIndex: {
    type: Number
  },
  mode: {
    type: String,
    "default": "modal",
    validator: function validator(val) {
      if (!val) return true;
      return ["modal", "modeless"].includes(val);
    }
  },
  navigationArrow: {
    type: [Boolean, Function],
    "default": true
  },
  showOverlay: {
    type: Boolean,
    "default": void 0
  },
  title: {
    type: [String, Function]
  },
  trigger: {
    type: [String, Function]
  },
  viewerScale: {
    type: Object
  },
  visible: {
    type: Boolean,
    "default": void 0
  },
  defaultVisible: Boolean,
  zIndex: {
    type: Number
  },
  onClose: Function,
  onIndexChange: Function
};

export { props as default };
//# sourceMappingURL=props.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/image-viewer/props.js
// module id = null
// module chunks = 